const or = (...predicates) => {
  return traffic => {
    return predicates.some(predicate => {
      return predicate(traffic)
    })
  }
}

export default or



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/predicates/or.js